import ReactDOM from 'react-dom';
import React, {Component} from 'react';
import {register, poke} from 'bazar';

import axios from "axios";

import FormContainer from "./containers/FormContainer";
// import {Order} from "./containers/FormContainer";
// import store_data from 'store_data12'


var products = [];

function checkDataForNull() {
    if (window.data !== null || window.data !== NaN) {
        products = window.data;
        console.log("Products Array:", products)
    } else {
        products = [];
    }
    return products;
};

function checkCatForNull(arr) {
    for (let i = 0; i < arr.length; i++) {
        if (arr[i].Category == null) {
            arr[i].Category = "Без категории";
            // console.log(products[i].Category);
        }
    }
    return arr;
};

function sortByCategory(arr) {
    arr.sort((a, b) => a.Category < b.Category ? 1 : -1);
    // data = data.filter(function(entry) { entry.count > 0 })
    // console.log("arr", arr);
    return arr;
};


checkDataForNull();
checkCatForNull(products);
sortByCategory(products);

console.log(products);

function sortByPriority(arr = [], params = ["Монопорционе"], endParams = ["Джелато", "Без категории"]) {

    let data = arr.slice(0);

    let result = [];
    // let params = ["Без категории", "Монопорционе", "Джелато Фруктовое", "Пастичини"];
    // let params = ["Монопорционе"];
    for (let a = 0; a < params.length; a++) {
        console.log(params[a]);
        for (let i = 0; i < data.length; i++) {
            if (data[i].Category === params[a]) {
                result.push(data[i]);
                data[i] = "null";
            }
        }// console.log(data);
    }
    ;
    data = data.filter(item => item !== "null");

    let resultEnd = [];
    for (let a = 0; a < endParams.length; a++) {
        console.log(endParams[a]);
        for (let i = 0; i < data.length; i++) {
            if (data[i].Category === endParams[a]) {
                resultEnd.push(data[i]);
                // data.splice(i, 1);
                data[i] = "null_end";
                // console.log(i);
            }
        }// console.log(data);
    }
    ;
    data = data.filter(item => item !== "null_end");

    // console.log(result);
    // result = result.concat(data);
    // const res = [];
    let res = result.concat(data);
    res = res.concat(resultEnd);
    // let res = resultM.concat(resultE);
    console.log(" Result: ", result, resultEnd, data, res);
    return res;
};


// var p = ["Монопорционе", "Джелато Фруктовое", "Пастичини", "Без категории"];
products = sortByPriority(products);
var products = products.filter(item => item.Stop !== true);
// console.log(products);

// const MediaPath = "media/products/";
const MediaPath = "https://farinaristore.blob.core.windows.net/media/";


const Item = props => {
    // const { Title, Price, hex, text } = props.product;
    const {ID, Title, Price, Description, Category, Stop, quantity, Weight} = props.product;

    const buy = () =>
        poke("App", {
            ID,
            Title,
            Description,
            Price,
            Stop,
            Weight,
            type: "increment"
        });

    const unbuy = () =>
        poke("App", {
            ID,
            Title,
            Description,
            Price,
            Stop,
            Weight,
            type: "decrement"
        });

    // const MediaPath = "media/products/";
    return (
        // <div className="container " key={{product: Category}}> {Category}
        // <div className="col-lg-6 col-md-6 mb-4 " key={{product: ID}}>

        // <div className="col-lg-6 col-md-6 mb-4 " id={Category + ID} key={{product: ID}}>
        <div className="mb-4 col-12  col-md-12  col-lg-6" id={Category + ID} key={{product: ID}}>
            {/*<div>*/}
            {/*<h3>{item.title}</h3>*/}
            {/*<p>{item.content}</p>*/}
            {/*</div>*/}


            <div class="card h-100 make-it-slow ">
                {/*<div className="card h-100 make-it-slow">*/}
                {/*<img class="card-img-top" src={MediaPath + ID + ".jpg"} alt=""></img> make-it-slow*/}
                {/*"media/products/"*/}
                {/*<div className="card-body" onClick={() => buy()}>*/}
                <div className="card-body">
                    <div className="card-title row">
                        <h5 className="col-8">
                            {/*<a href="#">Джелато Сливочное </a>*/}
                            {Title}
                        </h5>
                        <h4 className="col-4"> {Price} ₽</h4>

                    </div>
                    {/*<div className="card-body">*/}
                    <img className="img-fluid card-img-bottom" src={MediaPath + ID + ".jpg"} alt=""></img>
                    {/*<p>{quantity}</p>*/}
                    {/*<p>{Price*quantity} ₽</p>*/}
                    {/*<button className="btn-sm btn-outline-success" onClick={() => buy()}>➕</button><> </>*/}
                    {/*{quantity <= 0 &&*/}
                    {/*    <button className="btn-sm btn-outline-danger" disabled>➖</button>*/}
                    {/*}*/}
                    {/*{quantity >= 1 &&*/}
                    {/*<button className="btn-sm btn-outline-danger" onClick={() => unbuy()}>➖</button>*/}
                    {/*}*/}
                    {/*{Price*quantity} ₽*/}

                    {/*{quantity >= 1 &&*/}
                    {/*' x '+ quantity*/}
                    {/*}*/}
                    <p></p>
                    <p className="">{Description}</p>
                    {/*<h5 className="align-text-bottom"><b> {Weight}</b> грамм </h5>*/}
                </div>
                {Weight ?
                    // <div className="card-body border-light">
                    <div className="card-footer border-white bg-white"><h4 className="mt-auto align-self-end text-left">
                        <b> {Weight}</b> грамм </h4></div>
                    // </div>
                    : null}

                {/*<div className="card-body border-light">*/}
                {/*    <h4 className="text-left"><b> {Weight}</b> грамм </h4>*/}
                {/*</div>*/}

                <div className="card-footer">
                    <div className="row">
                        <h4 className="col-6 align-self-start row">
                            <button className="btn-sm btn-outline-success mr-2" onClick={() => buy()}>➕</button>

                            {quantity <= 0 &&
                            <button className="btn-sm btn-outline-danger" disabled>➖</button>
                            }
                            {quantity >= 1 &&
                            <button className="btn-sm btn-outline-danger" onClick={() => unbuy()}>➖</button>
                            }
                        </h4>
                        {/*{Price * quantity} ₽*/}

                        {quantity >= 1 &&

                        <h4 className="col">
                            x{quantity}
                        </h4>
                        }
                        {quantity <= 0 &&

                        <h4 className="col">

                        </h4>

                        }

                        {/*<h5 className="col-8">*/}
                        {/*    x{quantity}*/}
                        {/*</h5>*/}
                        <h4 className="col-4"> {Price * quantity} ₽</h4>
                    </div>
                </div>

            </div>

        </div>
        // </div>

    );
};


const Shop = props => {
    const items = () => {
        return props.products.map((product, index) => {
            return <Item product={product} key={index}/>;
        });
    };

    return <div class="row">{items()}</div>;
};

// let totalM = 0;
const Cart = props => {
    let total = 0;
    const purchases = props.items.map((item, index) => {
        const {Title, Price, quantity} = item;
        const currentImport = quantity * Price;
        total += currentImport;
        // console.log("fuck it" + total);
        return (

            <li className="list-group-item" key={index}>
                <ul className="text-center">
                    <span className="cartTitle">{Title}</span>
                    <span className="cartColorQty"> x {item.quantity}</span>
                    {/*{console.log(item.quantity)}*/}

                </ul>
                <br/>
                <ul className="text-center">
                    <button className="btn-sm btn-outline-success"
                            onClick={() => poke("App", {Title, type: "increment"})}>
                        ➕
                    </button>
                    <>  </>
                    <button className="btn-sm btn-outline-danger"
                            onClick={() => poke("App", {Title, type: "decrement"})}>
                        ➖
                    </button>
                    <span className="cartColorImport "> {currentImport} ₽ </span>
                    <button className="btn-sm btn-outline-warning" onClick={() => poke("App", {Title, type: "remove"})}>
                        🗑
                    </button>
                </ul>
            </li>

        );

    });

    return (

        <div class="Cart ">
            <div className="row position-bottom">
                <h4 className="mt-1 text-center ">Общая сумма {total} ₽</h4>
                {/*<strong className="text-center">Общая сумма {total} ₽</strong>*/}
            </div>

            {/*<ul>{purchases.length === 0 ? "empty (:" : purchases}</ul>*/}
            <div className="inCard">
                {purchases.length === 0 ? "" : purchases}
            </div>
            {/*{console.log(this.state)}*/}
            {/*<div class="cartTotal">$ {total}</div>*/}

            {/*<div className="container fixed-bottom bg-light">*/}
            {/*    <h3>В корзине</h3>*/}
            {/*    <button*/}
            {/*        className="btn btn-primary btn-block waves-effect waves-light mobile"*/}
            {/*        // onClick={props.changeView}*/}
            {/*    > Оформить заказ <h4>{total}</h4> </button>*/}
            {/*    <p></p>*/}
            {/*</div>*/}
        </div>

    );
};


class App extends Component {

    constructor(props) {
        super(props);
        this.state = {
            products: products.map(e => ({
                ...e,
                quantity: 0
            }))
        };

        register({
            id: "App",
            sync: () => this.state,
            onPoke: arg => {
                const {Title, type} = arg;
                // console.log('poked', Title);
                // console.log(products);
                const {products} = this.state;
                // console.log(products);
                this.setState({
                    products: products.map(e => {
                        const {quantity} = e;
                        // console.log(quantity);
                        return e.Title === Title ? {
                                ...e,
                                quantity: (() => {
                                    if (type === "increment") return quantity + 1;
                                    else if (type === "remove") return 0;
                                    return quantity - 1;
                                })()
                            }
                            : e;
                    })
                });
            },
        });

        this.changeView = this.changeView.bind(this);
        // this.splicesArray = this.splicesArray.bind(this);
    }

    // Надо переделать
    changeView = where => this.setState({view: where});

    // function splicesArray(e){
    //     e.splice(e.map(el => el.quantity).indexOf(0), 1);
    //     return(e);
    // };

    // splicesArray = products.splice(products.map(el => el.quantity).indexOf(0), 1);


    render() {
        const {view = "shop", products} = this.state;
        // var {view = "FormContainer", products} = this.state;

        const quantity = products.map(e => e.quantity).reduce((a, b) => a + b);
        // console.log(quantity);

        // const priceM = products.map(e => e.quantity).reduce(
        //     function (sum, current) {
        //         return sum + current;
        //     },
        //     0);
        const priceM = products.map(function (product) {
            let a = 0;
            if (product.quantity >= 1) {
                a = product.Price * product.quantity;
                // return product.Price * product.quantity;
            }
            return a;
            // return product.length;
        }).reduce((a, b) => a + b);


        const inCart = products.filter(e => e.quantity > 0);

        // console.log(inCart.quantity);
        // console.log(this.state);
        // console.log(poke)

        // var orderProducts = [];
        // orderProducts = products;

        // console.log(products);

        // console.log(orderProducts);

        // return (
        //     <div class="App">
        //         <div className="container">
        //             {/*<div className="row">*/}
        //
        //
        //             {view === "shop" ?
        //
        //                 <div className="container-fluid">
        //                     <div className="row d-flex">
        //
        //                         {/*<div className="col-lg-2 category position-fixed">*/}
        //                         {/*<aside className="col-2 px-0 fixed-top category">*/}
        //                         <aside className="col-2 mt-3 ml-3 container-my fixed-top category" >
        //
        //                             <h4 className="mt-1 text-center ">Категории</h4>
        //                             <div className="list-group">
        //                                 <a href="#Монопорционе337" className="list-group-item">Монопорционе</a>
        //                                 <a href="#Эклеры2239" className="list-group-item">Эклеры</a>
        //                                 <a href="#Торты359" className="list-group-item">Торты</a>
        //                                 <a href="#Печенья446" className="list-group-item">Печенья</a>
        //                                 <a href="#Макаруны331" className="list-group-item">Макаруны</a>
        //                                 <a href="#Джелато111" className="list-group-item">Джелато</a>
        //                                 {/*<a href="#Без категории231" className="list-group-item">Без категории</a>*/}
        //                             </div>
        //
        //                         </aside>
        //                         {/*<Category/>*/}
        //
        //                         <main className="col-lg-8 col-md-12">
        //
        //                             {/*<h1 className="my-4">Категории</h1>*/}
        //                             {/*<div className="list-group">*/}
        //                             {/*    <a href="#" className="list-group-item">Category 1</a>*/}
        //                             {/*    <a href="#" className="list-group-item">Category 2</a>*/}
        //                             {/*    <a href="#" className="list-group-item">Category 3</a>*/}
        //                             {/*</div>*/}
        //
        //                             <div className="row">
        //                                 <Shop products={products}/>
        //
        //                             </div>
        //                             <br/><br/>
        //                         </main>
        //                         <div className="col-md-2 col-lg-2 ">
        //
        //                             <div id="cart" className="container position-fixed w-25 align-items-center">
        //                                 <ul className="list-group list-group-flush ">
        //                                     {/*<ul className="list-group ">*/}
        //                                     <Cart items={inCart}/>
        //
        //                                 </ul>
        //
        //                                 <button type="button"
        //                                         className="btn btn-primary btn-block waves-effect waves-light "
        //                                         onClick={this.changeView}>
        //                                     {/*{inCart.total}*/}
        //                                     Оформить заказ
        //                                 </button>
        //                                 <footer>
        //                                     <br/>
        //                                     <h5 align="center">Часы работы с 9:00 до 21:00. Дата и стоимость доставки
        //                                         рассчитываются индивидуально.</h5>
        //                                     <br/>
        //                                     <span>Сайт предоставлен в ознакомительных целях и не является публичной офертой. Все права защищены.</span><span>Farinari 2021</span>
        //                                 </footer>
        //
        //                                 <div className="container fixed-bottom bg-light button-mob border">
        //                                     {/*<h3>В корзину</h3>*/}
        //                                     {/*<h4>{quantity}</h4>*/}
        //                                     {/*<h4>{priceM}</h4>*/}
        //                                     <p></p>
        //                                     <div className="row">
        //                                         <h5 className="col text-left">x {quantity}</h5>
        //                                         <button type="button"
        //                                             // className="btn btn-primary btn-block waves-effect waves-light col"
        //                                                 className="btn btn-primary btn-block waves-effect waves-light col-6"
        //                                                 onClick={this.changeView}
        //                                         >Оформить заказ
        //                                         </button>
        //                                         <h5 className="col text-right">{priceM} ₽</h5>
        //                                     </div>
        //                                     <p></p>
        //                                 </div>
        //                                 {/*<button type="button"*/}
        //                                 {/*        className="btn btn-primary btn-block waves-effect waves-light"*/}
        //                                 {/*        onClick={splicesArray}>*/}
        //                                 {/*    Оформить заказ*/}
        //                                 {/*</button>*/}
        //                             </div>
        //                         </div>
        //                     </div>
        //                 </div>
        //
        //                 :
        //
        //                 // <div className="justify-content-center">
        //                 <div className="content-center d-flex justify-content-center">
        //                     {/*<div className="col-lg-9 ">*/}
        //                     <div className="col-lg-9 ">
        //                         {/*<div className="justify-content-center col-md-8">*/}
        //                         {/*<div className="justify-content-center">*/}
        //
        //                         <div className="row">
        //                             {/*{console.log("Тест доступности",products)}*/}
        //                             <FormContainer products={products}/>
        //
        //                         </div>
        //                     </div>
        //                 </div>
        //             }
        //
        //
        //         </div>
        //
        //     </div>
        //
        // );
        return (
            <div className="">
                {view === "shop" ?
                    <article>
                        <div className="container-fluid maxWidth">
                            {/*<div className="row">*/}
                            {/*    <div className="col">*/}
                            {/*        <div className="title-section">*/}
                            {/*            <h1>Basic Sticky Sidebar with Bootstrap 4</h1>*/}
                            {/*        </div>*/}
                            {/*    </div>*/}
                            {/*</div>*/}

                            <div className="row">
                                <div className="col-3 catAndInCard">

                                    <div className="sidebar-item">
                                        <div className="make-me-sticky"><br/><br/><br/>

                                            {/*<h3>Item 1</h3>*/}
                                            <div className="mr-3">

                                                <h4 className="mt-1 text-center ">Категории</h4>
                                                <div className="list-group text-center">
                                                    <a href="#Монопорционе337"
                                                       className="list-group-item">Монопорционе</a>
                                                    <a href="#Эклеры2239" className="list-group-item">Эклеры</a>
                                                    <a href="#Торты359" className="list-group-item">Торты</a>
                                                    <a href="#Печенья446" className="list-group-item">Печенья</a>
                                                    <a href="#Макаруны331" className="list-group-item">Макаруны</a>
                                                    <a href="#Джелато111" className="list-group-item">Джелато</a>
                                                    {/*<a href="#Без категории231" className="list-group-item">Без категории</a>*/}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                {/*<div className="col-6 ">*/}
                                <div className="col ">

                                    {/*<div className="content-section">*/}

                                    {/*    <h2>Content</h2>*/}

                                    <main className="">

                                        {/*<h1 className="my-4">Категории</h1>*/}
                                        {/*<div className="list-group">*/}
                                        {/*    <a href="#" className="list-group-item">Category 1</a>*/}
                                        {/*    <a href="#" className="list-group-item">Category 2</a>*/}
                                        {/*    <a href="#" className="list-group-item">Category 3</a>*/}
                                        {/*</div>*/}

                                        <div className="row">
                                            <Shop products={products}/>

                                        </div>
                                        <br/><br/>
                                    </main>
                                    {/*</div>*/}

                                </div>
                                <div className="col-3 catAndInCard">

                                    <div className="sidebar-item">
                                        <div className="make-me-sticky "><br/><br/><br/>

                                            <div className="ml-3">

                                                {/*<h3>Item 2</h3>*/}
                                                {/*<div id="cart" className="container position-fixed w-25 align-items-center">*/}
                                                {/*<div id="cart" className="make-me-sticky">*/}
                                                {/*<ul className="list-group list-group-flush row inCard">*/}
                                                <ul className="list-group list-group-flush row">
                                                    {/*<ul className="list-group ">*/}
                                                    <Cart items={inCart}/>

                                                </ul>

                                                <button type="button"
                                                        className="btn btn-primary btn-block waves-effect waves-light "
                                                        onClick={this.changeView}>
                                                    {/*{inCart.total}*/}
                                                    Оформить заказ
                                                </button>


                                                {/*</div>*/}
                                                <footer className="text-center">
                                                    <br/>
                                                    <h4 align="center">Часы работы с 9:00 до 21:00. Дата и стоимость
                                                        доставки
                                                        рассчитываются индивидуально.
                                                    </h4>

                                                    <span>Сайт предоставлен в ознакомительных целях и не является публичной офертой. Все права защищены.</span>
                                                    <br/>
                                                    <span>Farinari 2021</span>
                                                </footer>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/*Мобильная кнопка*/}
                                <div className="container fixed-bottom bg-light  border col-12">
                                    <p></p>
                                    <div className="button-mob">
                                        <div className="row">
                                            <b className="col-3 text-right mt-1">x {quantity}</b>
                                            <button type="button"
                                                // className="btn btn-primary btn-block waves-effect waves-light col"
                                                    className="btn btn-primary btn-block waves-effect waves-light col-6 mb-1"
                                                    onClick={this.changeView}
                                            >Оформить заказ
                                            </button>
                                            <b className="col-3 text-left mt-1">{priceM} ₽</b>
                                        </div>
                                        <p></p>
                                    </div>
                                </div>


                            </div>
                        </div>
                    </article>
                    :
                    // <div className="justify-content-center">
                    <div className="content-center d-flex justify-content-center">
                        {/*<div className="col-lg-9 ">*/}
                        <div className="col-lg-9 ">
                            {/*<div className="justify-content-center col-md-8">*/}
                            {/*<div className="justify-content-center">*/}

                            <div className="row">
                                {/*{console.log("Тест доступности",products)}*/}
                                <FormContainer products={products}/>

                            </div>
                        </div>
                    </div>
                }
            </div>
        );

    };
};

// console.log(orderProducts);

ReactDOM.render(<App/>, document.getElementById('App'));


